import { render, staticRenderFns } from "./MdPaginationItem.vue?vue&type=template&id=1d87368e&"
import script from "./MdPaginationItem.vue?vue&type=script&lang=js&"
export * from "./MdPaginationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports